import { Grid } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { AllowanceCap } from './AllowanceCap';
import { AmountPerMile } from './AmountPerMile';
import { Billable } from './Billable';
import { PayableTo } from './PayableTo';
import { Payer } from './Payer';

const useStyles = makeStyles()(theme => ({
  dateContainer: {
    minWidth: '350px',
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    padding: '10px',
    minWidth: '350px',
  },
  root: {
    flexGrow: 1,
  },
}));

export const EndingTravelMod = () => {
  const { classes } = useStyles();
  return (
    <>
      <div className={classes.root}>
        <Grid container direction="column" spacing={4} className={classes.gridContainer}>
          <Grid xs={12} item className={classes.dateContainer}>
            <Payer />
          </Grid>
          <Grid xs={12} item className={classes.dateContainer}>
            <PayableTo />
          </Grid>
          <Grid xs={12} item className={classes.dateContainer}>
            <AmountPerMile />
          </Grid>
          <Grid xs={12} item className={classes.dateContainer}>
            <AllowanceCap />
          </Grid>
          <Grid xs={12} item className={classes.dateContainer}>
            <Billable />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
